import React from 'react';
import { useCookieConsent } from '../../context/CookieConsentContext';
import { useAuth } from '../../context/AuthContext';
import './CookiePreferencesTrigger.css';

const CookiePreferencesTrigger = () => {
  const { hasDecided, isPreferencesOpen, isBannerVisible, openPreferences } = useCookieConsent();
  const { isAuthenticated } = useAuth();

  if (isAuthenticated || !hasDecided || isPreferencesOpen || isBannerVisible) {
    return null;
  }

  return (
    <button
      type="button"
      className="cookie-preferences-trigger"
      onClick={openPreferences}
      aria-label="Gestionar preferencias de cookies"
    >
      Cookies
    </button>
  );
};

export default CookiePreferencesTrigger;
